var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleDesktopGe(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7409.35 5552.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.1;}.cls-1,.cls-2,.cls-3{fill:lime;}.cls-4{fill:#ccc;}.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}.cls-3{opacity:.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 944.82,
    width: 7396.09,
    height: 4584.31
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5545.58 2091.45 5545.58 2126.21 4326.69 2126.22 4326.69 980.69 4361.96 980.69 4361.96 945.93 5508.59 945.93 5508.59 2091.45 5545.58 2091.45"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 979.58,
    x2: 7396.08,
    y2: 979.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1016.57,
    x2: 7396.08,
    y2: 1016.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1053.56,
    x2: 7396.08,
    y2: 1053.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1090.55,
    x2: 7396.08,
    y2: 1090.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1127.54,
    x2: 7396.08,
    y2: 1127.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1164.52,
    x2: 7396.08,
    y2: 1164.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1201.51,
    x2: 7396.08,
    y2: 1201.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1238.5,
    x2: 7396.08,
    y2: 1238.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1275.49,
    x2: 7396.08,
    y2: 1275.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1312.48,
    x2: 7396.08,
    y2: 1312.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1349.46,
    x2: 7396.08,
    y2: 1349.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1386.45,
    x2: 7396.08,
    y2: 1386.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1423.44,
    x2: 7396.08,
    y2: 1423.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1460.43,
    x2: 7396.08,
    y2: 1460.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1497.42,
    x2: 7396.08,
    y2: 1497.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1534.4,
    x2: 7396.08,
    y2: 1534.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1571.39,
    x2: 7396.08,
    y2: 1571.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1608.38,
    x2: 7396.08,
    y2: 1608.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1645.37,
    x2: 7396.08,
    y2: 1645.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1682.36,
    x2: 7396.08,
    y2: 1682.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1719.35,
    x2: 7396.08,
    y2: 1719.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1756.33,
    x2: 7396.08,
    y2: 1756.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1793.32,
    x2: 7396.08,
    y2: 1793.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1830.31,
    x2: 7396.08,
    y2: 1830.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1867.3,
    x2: 7396.08,
    y2: 1867.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1904.29,
    x2: 7396.08,
    y2: 1904.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1941.27,
    x2: 7396.08,
    y2: 1941.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 1978.26,
    x2: 7396.08,
    y2: 1978.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2015.25,
    x2: 7396.08,
    y2: 2015.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2052.24,
    x2: 7396.08,
    y2: 2052.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2089.23,
    x2: 7396.08,
    y2: 2089.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2126.22,
    x2: 7396.08,
    y2: 2126.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2163.2,
    x2: 7396.08,
    y2: 2163.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2200.19,
    x2: 7396.08,
    y2: 2200.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2237.18,
    x2: 7396.08,
    y2: 2237.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2274.17,
    x2: 7396.08,
    y2: 2274.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2311.16,
    x2: 7396.08,
    y2: 2311.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2348.14,
    x2: 7396.08,
    y2: 2348.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2385.13,
    x2: 7396.08,
    y2: 2385.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2422.12,
    x2: 7396.08,
    y2: 2422.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2459.11,
    x2: 7396.08,
    y2: 2459.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2496.1,
    x2: 7396.08,
    y2: 2496.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2533.09,
    x2: 7396.08,
    y2: 2533.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2570.07,
    x2: 7396.08,
    y2: 2570.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2607.06,
    x2: 7396.08,
    y2: 2607.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2644.05,
    x2: 7396.08,
    y2: 2644.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2681.04,
    x2: 7396.08,
    y2: 2681.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2718.03,
    x2: 7396.08,
    y2: 2718.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2755.01,
    x2: 7396.08,
    y2: 2755.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2792,
    x2: 7396.08,
    y2: 2792
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2828.99,
    x2: 7396.08,
    y2: 2828.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2865.98,
    x2: 7396.08,
    y2: 2865.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2902.97,
    x2: 7396.08,
    y2: 2902.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2939.96,
    x2: 7396.08,
    y2: 2939.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 2976.94,
    x2: 7396.08,
    y2: 2976.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3013.93,
    x2: 7396.08,
    y2: 3013.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3050.92,
    x2: 7396.08,
    y2: 3050.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3087.91,
    x2: 7396.08,
    y2: 3087.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3124.9,
    x2: 7396.08,
    y2: 3124.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3161.88,
    x2: 7396.08,
    y2: 3161.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3198.87,
    x2: 7396.08,
    y2: 3198.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3235.86,
    x2: 7396.08,
    y2: 3235.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3272.85,
    x2: 7396.08,
    y2: 3272.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3309.84,
    x2: 7396.08,
    y2: 3309.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3346.82,
    x2: 7396.08,
    y2: 3346.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3383.81,
    x2: 7396.08,
    y2: 3383.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3420.8,
    x2: 7396.08,
    y2: 3420.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3457.79,
    x2: 7396.08,
    y2: 3457.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3494.78,
    x2: 7396.08,
    y2: 3494.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3531.77,
    x2: 7396.08,
    y2: 3531.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3568.75,
    x2: 7396.08,
    y2: 3568.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3605.74,
    x2: 7396.08,
    y2: 3605.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3642.73,
    x2: 7396.08,
    y2: 3642.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3679.72,
    x2: 7396.08,
    y2: 3679.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3716.71,
    x2: 7396.08,
    y2: 3716.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3753.69,
    x2: 7396.08,
    y2: 3753.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3790.68,
    x2: 7396.08,
    y2: 3790.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3827.67,
    x2: 7396.08,
    y2: 3827.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3864.66,
    x2: 7396.08,
    y2: 3864.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3901.65,
    x2: 7396.08,
    y2: 3901.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3938.64,
    x2: 7396.08,
    y2: 3938.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 3975.62,
    x2: 7396.08,
    y2: 3975.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4012.61,
    x2: 7396.08,
    y2: 4012.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4049.6,
    x2: 7396.08,
    y2: 4049.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4086.59,
    x2: 7396.08,
    y2: 4086.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4123.58,
    x2: 7396.08,
    y2: 4123.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4160.56,
    x2: 7396.08,
    y2: 4160.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4197.55,
    x2: 7396.08,
    y2: 4197.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4234.54,
    x2: 7396.08,
    y2: 4234.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4271.53,
    x2: 7396.08,
    y2: 4271.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4308.52,
    x2: 7396.08,
    y2: 4308.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4345.51,
    x2: 7396.08,
    y2: 4345.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4382.49,
    x2: 7396.08,
    y2: 4382.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4419.48,
    x2: 7396.08,
    y2: 4419.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4456.47,
    x2: 7396.08,
    y2: 4456.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4493.46,
    x2: 7396.08,
    y2: 4493.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4530.45,
    x2: 7396.08,
    y2: 4530.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4567.43,
    x2: 7396.08,
    y2: 4567.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4604.42,
    x2: 7396.08,
    y2: 4604.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4641.41,
    x2: 7396.08,
    y2: 4641.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4678.4,
    x2: 7396.08,
    y2: 4678.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4715.39,
    x2: 7396.08,
    y2: 4715.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4752.37,
    x2: 7396.08,
    y2: 4752.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4789.36,
    x2: 7396.08,
    y2: 4789.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4826.35,
    x2: 7396.08,
    y2: 4826.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4863.34,
    x2: 7396.08,
    y2: 4863.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4900.33,
    x2: 7396.08,
    y2: 4900.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4937.32,
    x2: 7396.08,
    y2: 4937.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 4974.3,
    x2: 7396.08,
    y2: 4974.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5011.29,
    x2: 7396.08,
    y2: 5011.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5048.28,
    x2: 7396.08,
    y2: 5048.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5085.27,
    x2: 7396.08,
    y2: 5085.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5122.26,
    x2: 7396.08,
    y2: 5122.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5159.24,
    x2: 7396.08,
    y2: 5159.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5196.23,
    x2: 7396.08,
    y2: 5196.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5233.22,
    x2: 7396.08,
    y2: 5233.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5270.21,
    x2: 7396.08,
    y2: 5270.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5307.2,
    x2: 7396.08,
    y2: 5307.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5344.19,
    x2: 7396.08,
    y2: 5344.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5381.17,
    x2: 7396.08,
    y2: 5381.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5418.16,
    x2: 7396.08,
    y2: 5418.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5455.15,
    x2: 7396.08,
    y2: 5455.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5492.14,
    x2: 7396.08,
    y2: 5492.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0,
    y1: 5529.13,
    x2: 7396.08,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4584.51,
    y1: 944.82,
    x2: 4584.52,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4547.52,
    y1: 944.82,
    x2: 4547.53,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4510.54,
    y1: 944.82,
    x2: 4510.54,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4473.55,
    y1: 944.82,
    x2: 4473.55,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4436.56,
    y1: 944.82,
    x2: 4436.56,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4399.57,
    y1: 944.82,
    x2: 4399.57,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4362.58,
    y1: 944.82,
    x2: 4362.59,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4325.6,
    y1: 944.82,
    x2: 4325.6,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4288.61,
    y1: 944.82,
    x2: 4288.61,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4251.62,
    y1: 944.82,
    x2: 4251.62,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4214.63,
    y1: 944.82,
    x2: 4214.63,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4177.64,
    y1: 944.82,
    x2: 4177.65,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4140.65,
    y1: 944.82,
    x2: 4140.66,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4103.67,
    y1: 944.82,
    x2: 4103.67,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4066.68,
    y1: 944.82,
    x2: 4066.68,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4029.69,
    y1: 944.82,
    x2: 4029.69,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3992.7,
    y1: 944.82,
    x2: 3992.7,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3955.71,
    y1: 944.82,
    x2: 3955.72,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3918.73,
    y1: 944.82,
    x2: 3918.73,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3881.74,
    y1: 944.82,
    x2: 3881.74,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3844.75,
    y1: 944.82,
    x2: 3844.75,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3807.76,
    y1: 944.82,
    x2: 3807.76,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3770.77,
    y1: 944.82,
    x2: 3770.78,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3733.78,
    y1: 944.82,
    x2: 3733.79,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3696.8,
    y1: 944.82,
    x2: 3696.8,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3659.81,
    y1: 944.82,
    x2: 3659.81,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3622.82,
    y1: 944.82,
    x2: 3622.82,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3585.83,
    y1: 944.82,
    x2: 3585.83,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3548.84,
    y1: 944.82,
    x2: 3548.85,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3511.86,
    y1: 944.82,
    x2: 3511.86,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3474.87,
    y1: 944.82,
    x2: 3474.87,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3437.88,
    y1: 944.82,
    x2: 3437.88,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3400.89,
    y1: 944.82,
    x2: 3400.89,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3363.9,
    y1: 944.82,
    x2: 3363.91,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3326.92,
    y1: 944.82,
    x2: 3326.92,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3289.93,
    y1: 944.82,
    x2: 3289.93,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3252.94,
    y1: 944.82,
    x2: 3252.94,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3215.95,
    y1: 944.82,
    x2: 3215.95,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3178.96,
    y1: 944.82,
    x2: 3178.97,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3141.97,
    y1: 944.82,
    x2: 3141.98,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3104.99,
    y1: 944.82,
    x2: 3104.99,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3068,
    y1: 944.82,
    x2: 3068,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3031.01,
    y1: 944.82,
    x2: 3031.01,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2994.02,
    y1: 944.82,
    x2: 2994.02,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2957.03,
    y1: 944.82,
    x2: 2957.04,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2920.05,
    y1: 944.82,
    x2: 2920.05,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2883.06,
    y1: 944.82,
    x2: 2883.06,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2846.07,
    y1: 944.82,
    x2: 2846.07,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2809.08,
    y1: 944.82,
    x2: 2809.08,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2772.09,
    y1: 944.82,
    x2: 2772.1,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2735.1,
    y1: 944.82,
    x2: 2735.11,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2698.12,
    y1: 944.82,
    x2: 2698.12,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2661.13,
    y1: 944.82,
    x2: 2661.13,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2624.14,
    y1: 944.82,
    x2: 2624.14,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2587.15,
    y1: 944.82,
    x2: 2587.15,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2550.16,
    y1: 944.82,
    x2: 2550.17,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2513.18,
    y1: 944.82,
    x2: 2513.18,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2476.19,
    y1: 944.82,
    x2: 2476.19,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2439.2,
    y1: 944.82,
    x2: 2439.2,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2402.21,
    y1: 944.82,
    x2: 2402.21,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2365.22,
    y1: 944.82,
    x2: 2365.23,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2328.23,
    y1: 944.82,
    x2: 2328.24,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2291.25,
    y1: 944.82,
    x2: 2291.25,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2254.26,
    y1: 944.82,
    x2: 2254.26,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2217.27,
    y1: 944.82,
    x2: 2217.27,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2180.28,
    y1: 944.82,
    x2: 2180.28,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2143.29,
    y1: 944.82,
    x2: 2143.3,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2106.31,
    y1: 944.82,
    x2: 2106.31,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2069.32,
    y1: 944.82,
    x2: 2069.32,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2032.33,
    y1: 944.82,
    x2: 2032.33,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1995.34,
    y1: 944.82,
    x2: 1995.34,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1958.35,
    y1: 944.82,
    x2: 1958.36,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1921.37,
    y1: 944.82,
    x2: 1921.37,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1884.38,
    y1: 944.82,
    x2: 1884.38,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1847.39,
    y1: 944.82,
    x2: 1847.39,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1810.4,
    y1: 944.82,
    x2: 1810.4,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1773.41,
    y1: 944.82,
    x2: 1773.42,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1736.42,
    y1: 944.82,
    x2: 1736.43,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1699.44,
    y1: 944.82,
    x2: 1699.44,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1662.45,
    y1: 944.82,
    x2: 1662.45,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1625.46,
    y1: 944.82,
    x2: 1625.46,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1588.47,
    y1: 944.82,
    x2: 1588.47,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1551.48,
    y1: 944.82,
    x2: 1551.49,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1514.5,
    y1: 944.82,
    x2: 1514.5,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1477.51,
    y1: 944.82,
    x2: 1477.51,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1440.52,
    y1: 944.82,
    x2: 1440.52,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1403.53,
    y1: 944.82,
    x2: 1403.53,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1366.54,
    y1: 944.82,
    x2: 1366.55,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1329.55,
    y1: 944.82,
    x2: 1329.56,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1292.57,
    y1: 944.82,
    x2: 1292.57,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1255.58,
    y1: 944.82,
    x2: 1255.58,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1218.59,
    y1: 944.82,
    x2: 1218.59,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1181.6,
    y1: 944.82,
    x2: 1181.6,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1144.61,
    y1: 944.82,
    x2: 1144.62,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1107.63,
    y1: 944.82,
    x2: 1107.63,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1070.64,
    y1: 944.82,
    x2: 1070.64,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1033.65,
    y1: 944.82,
    x2: 1033.65,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 996.66,
    y1: 944.82,
    x2: 996.66,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 959.67,
    y1: 944.82,
    x2: 959.68,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 922.68,
    y1: 944.82,
    x2: 922.69,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 885.7,
    y1: 944.82,
    x2: 885.7,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 848.71,
    y1: 944.82,
    x2: 848.71,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 811.72,
    y1: 944.82,
    x2: 811.72,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 774.73,
    y1: 944.82,
    x2: 774.73,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 737.74,
    y1: 944.82,
    x2: 737.75,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 700.76,
    y1: 944.82,
    x2: 700.76,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 663.77,
    y1: 944.82,
    x2: 663.77,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 626.78,
    y1: 944.82,
    x2: 626.78,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 589.79,
    y1: 944.82,
    x2: 589.79,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 552.8,
    y1: 944.82,
    x2: 552.81,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 515.81,
    y1: 944.82,
    x2: 515.82,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 478.83,
    y1: 944.82,
    x2: 478.83,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 441.84,
    y1: 944.82,
    x2: 441.84,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 404.85,
    y1: 944.82,
    x2: 404.85,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 367.86,
    y1: 944.82,
    x2: 367.86,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 330.87,
    y1: 944.82,
    x2: 330.88,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 293.89,
    y1: 944.82,
    x2: 293.89,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 256.9,
    y1: 944.82,
    x2: 256.9,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 219.91,
    y1: 944.82,
    x2: 219.91,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 182.92,
    y1: 944.82,
    x2: 182.92,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.93,
    y1: 944.82,
    x2: 145.94,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.95,
    y1: 944.82,
    x2: 108.95,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.96,
    y1: 944.82,
    x2: 71.96,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 34.97,
    y1: 944.82,
    x2: 34.97,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7396.08,
    y1: 944.82,
    x2: 7396.09,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7359.1,
    y1: 944.82,
    x2: 7359.1,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7322.11,
    y1: 944.82,
    x2: 7322.11,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7285.12,
    y1: 944.82,
    x2: 7285.12,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7248.13,
    y1: 944.82,
    x2: 7248.13,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7211.14,
    y1: 944.82,
    x2: 7211.15,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7174.15,
    y1: 944.82,
    x2: 7174.16,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7137.17,
    y1: 944.82,
    x2: 7137.17,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7100.18,
    y1: 944.82,
    x2: 7100.18,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7063.19,
    y1: 944.82,
    x2: 7063.19,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7026.2,
    y1: 944.82,
    x2: 7026.2,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6989.21,
    y1: 944.82,
    x2: 6989.22,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6952.23,
    y1: 944.82,
    x2: 6952.23,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6915.24,
    y1: 944.82,
    x2: 6915.24,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6878.25,
    y1: 944.82,
    x2: 6878.25,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6841.26,
    y1: 944.82,
    x2: 6841.26,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6804.27,
    y1: 944.82,
    x2: 6804.28,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6767.28,
    y1: 944.82,
    x2: 6767.29,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6730.3,
    y1: 944.82,
    x2: 6730.3,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6693.31,
    y1: 944.82,
    x2: 6693.31,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6656.32,
    y1: 944.82,
    x2: 6656.32,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6619.33,
    y1: 944.82,
    x2: 6619.33,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6582.34,
    y1: 944.82,
    x2: 6582.35,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6545.36,
    y1: 944.82,
    x2: 6545.36,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6508.37,
    y1: 944.82,
    x2: 6508.37,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6471.38,
    y1: 944.82,
    x2: 6471.38,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6434.39,
    y1: 944.82,
    x2: 6434.39,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6397.4,
    y1: 944.82,
    x2: 6397.41,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6360.41,
    y1: 944.82,
    x2: 6360.42,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6323.43,
    y1: 944.82,
    x2: 6323.43,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6286.44,
    y1: 944.82,
    x2: 6286.44,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6249.45,
    y1: 944.82,
    x2: 6249.45,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6212.46,
    y1: 944.82,
    x2: 6212.46,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6175.47,
    y1: 944.82,
    x2: 6175.48,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6138.49,
    y1: 944.82,
    x2: 6138.49,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6101.5,
    y1: 944.82,
    x2: 6101.5,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6064.51,
    y1: 944.82,
    x2: 6064.51,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6027.52,
    y1: 944.82,
    x2: 6027.52,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5990.53,
    y1: 944.82,
    x2: 5990.54,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5953.55,
    y1: 944.82,
    x2: 5953.55,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5916.56,
    y1: 944.82,
    x2: 5916.56,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5879.57,
    y1: 944.82,
    x2: 5879.57,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5842.58,
    y1: 944.82,
    x2: 5842.58,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5805.59,
    y1: 944.82,
    x2: 5805.6,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5768.6,
    y1: 944.82,
    x2: 5768.61,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5731.62,
    y1: 944.82,
    x2: 5731.62,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5694.63,
    y1: 944.82,
    x2: 5694.63,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5657.64,
    y1: 944.82,
    x2: 5657.64,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5620.65,
    y1: 944.82,
    x2: 5620.65,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5583.66,
    y1: 944.82,
    x2: 5583.67,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5546.68,
    y1: 944.82,
    x2: 5546.68,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5509.69,
    y1: 944.82,
    x2: 5509.69,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5472.7,
    y1: 944.82,
    x2: 5472.7,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5435.71,
    y1: 944.82,
    x2: 5435.71,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5398.72,
    y1: 944.82,
    x2: 5398.73,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5361.73,
    y1: 944.82,
    x2: 5361.74,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5324.75,
    y1: 944.82,
    x2: 5324.75,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5287.76,
    y1: 944.82,
    x2: 5287.76,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5250.77,
    y1: 944.82,
    x2: 5250.77,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5213.78,
    y1: 944.82,
    x2: 5213.78,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5176.79,
    y1: 944.82,
    x2: 5176.8,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5139.81,
    y1: 944.82,
    x2: 5139.81,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5102.82,
    y1: 944.82,
    x2: 5102.82,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5065.83,
    y1: 944.82,
    x2: 5065.83,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5028.84,
    y1: 944.82,
    x2: 5028.84,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4991.85,
    y1: 944.82,
    x2: 4991.86,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4954.86,
    y1: 944.82,
    x2: 4954.87,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4917.88,
    y1: 944.82,
    x2: 4917.88,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4880.89,
    y1: 944.82,
    x2: 4880.89,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4843.9,
    y1: 944.82,
    x2: 4843.9,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4806.91,
    y1: 944.82,
    x2: 4806.91,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4769.92,
    y1: 944.82,
    x2: 4769.93,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4732.94,
    y1: 944.82,
    x2: 4732.94,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4695.95,
    y1: 944.82,
    x2: 4695.95,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4658.96,
    y1: 944.82,
    x2: 4658.96,
    y2: 5529.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4621.97,
    y1: 944.82,
    x2: 4621.97,
    y2: 5529.13
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "zoom"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4346.36 954.09 4161.79 675.51 4159.44 345.49 4359.67 944.82 4360.09 976.9 4346.36 954.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3791.17 675.51 4327.95 976.9 4360.09 976.9 4161.79 675.51 3791.17 675.51"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "color-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4159.44 673.49 3793.79 673.49 3793.79 308.74 4122.45 308.74 4122.45 345.49 4159.44 345.49 4159.44 673.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4152.39,
    y: 277.4,
    width: 36.75,
    height: 36.75
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "grid-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4122.45 308.74 4122.45 343.73 4138.87 347.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3826.54,
    y1: 308.74,
    x2: 3826.54,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3863.53,
    y1: 308.74,
    x2: 3863.53,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3900.52,
    y1: 308.74,
    x2: 3900.52,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3937.51,
    y1: 308.74,
    x2: 3937.51,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3974.49,
    y1: 308.74,
    x2: 3974.5,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4011.48,
    y1: 308.74,
    x2: 4011.49,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4048.47,
    y1: 308.74,
    x2: 4048.47,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4085.46,
    y1: 308.74,
    x2: 4085.46,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4122.45,
    y1: 308.74,
    x2: 4122.45,
    y2: 673.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3793.79,
    y1: 345.5,
    x2: 4159.43,
    y2: 345.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.43,
    y1: 382.48,
    x2: 3793.79,
    y2: 382.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.43,
    y1: 419.47,
    x2: 3793.79,
    y2: 419.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 456.46,
    x2: 3793.79,
    y2: 456.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 493.44,
    x2: 3793.79,
    y2: 493.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 530.43,
    x2: 3793.79,
    y2: 530.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 567.42,
    x2: 3793.79,
    y2: 567.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 604.41,
    x2: 3793.79,
    y2: 604.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4159.44,
    y1: 641.4,
    x2: 3793.79,
    y2: 641.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleDesktopGe);
export default __webpack_public_path__ + "static/media/people-desktop-ge.d0db889213d38f67a642bb1becbe51a6.svg";
export { ForwardRef as ReactComponent };